import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { LayoutComponent } from './layout/layout.component';
import { AppRoutingModule } from '../app-routing.module';
import { HomeComponent } from './home/home.component';
import { HowToComponent } from './how-to/how-to.component';
import { CartComponent } from './cart/cart.component';
import { WallComponent } from './wall/wall.component';
import { ClickOutsideDirective } from '../common/directives/click-outside.directive';
import { ChooseImageScrollDirective } from '../common/directives/choose-image-scroll.directive';
import { PurchaseFlowComponent } from './purchase-flow/purchase-flow.component';
import { TilesComponent } from './purchase-flow/tiles/tiles.component';
import { PreviewComponent } from './purchase-flow/preview/preview.component';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NftInformationComponent } from './nft-information/nft-information.component';
import { PurchaseInfoPopupComponent } from './purchase-info-popup/purchase-info-popup.component';
import { CartItemComponent } from './cart-item/cart-item.component';
import { ChooseImageComponent } from './purchase-flow/choose-image/choose-image.component';
import { ToolboxComponent } from './toolbar/toolbox.component';

@NgModule({
  declarations: [
    ClickOutsideDirective,
    ChooseImageScrollDirective,
    PurchaseFlowComponent,
    HeaderComponent,
    LayoutComponent,
    HomeComponent,
    HowToComponent,
    CartComponent,
    HowToComponent,
    WallComponent,
    TilesComponent,
    PreviewComponent,
    NftInformationComponent,
    PurchaseInfoPopupComponent,
    CartItemComponent,
    ChooseImageComponent,
    ToolboxComponent,
  ],
  exports: [LayoutComponent],
  imports: [CommonModule, AppRoutingModule, SharedModule, ReactiveFormsModule],
})
export class ComponentsModule {}
